<script lang="ts">
  import { onMount } from "svelte";
  import type { UIComponent } from "@movabletype/app/ui";
  import HtmlElement from "./HtmlElement.svelte";
  export let namespace;
  export let detail;
  let components: UIComponent[] = [];
  let readiedCount = 0;
  const componentsPromise = window.MT.UI.Component.getAll(namespace);
  componentsPromise.then((_components) => {
    components = _components;
  });

  let elements: HTMLElement[] = [];
  let container: HTMLDivElement;
  function onReady(el: HTMLElement): void {
    if (++readiedCount !== components.length) {
      return;
    }

    [...container.childNodes]
      .filter((e): e is HTMLElement => e instanceof HTMLElement)
      .forEach((e: HTMLElement, i) => {
        e.style.order ||=
          (e.firstElementChild as HTMLElement)?.style.order || String((i + 1) * 100);
      });
  }

  function initCustomElement(el: HTMLElement): void {
    el.dispatchEvent(
      new CustomEvent("mt-component-init", {
        detail,
      }),
    );
    onReady(el);
  }

  onMount(() => {
    container.addEventListener("mt-component-update", (ev: CustomEvent) => {
      elements.forEach((e) => {
        e.dispatchEvent(new CustomEvent("mt-component-update", {
          detail: ev.detail,
        }));
      });
    });
  });
</script>

<div class="d-flex flex-column" bind:this={container}>
  <slot name="prepend" />

  {#each components as c}
    {#if typeof c === "string" && customElements.get(c)}
      <svelte:element this={c} use:initCustomElement on:mt-component-update />
    {:else}
      <HtmlElement
        element={c}
        event={new CustomEvent("mt-component-init", {
          detail,
        })}
        {onReady}
        on:mt-component-update
      />
    {/if}
  {/each}

  <slot name="append" />
</div>
